// Host-side copy of the end-user access token pushed through
// `window.$cloudchat.setAuthToken`. It is a credential, so it lives in this
// module variable and not on `window.$cloudchat` — that object is readable by
// any script on the page and shows up in `Object.entries`/`JSON.stringify`.
// Mirrors widget/helpers/forwardedAuthToken.js on the other side of the iframe.
let forwardedAuthToken = null;

export const setForwardedAuthToken = token => {
  forwardedAuthToken = token || null;
};

export const getForwardedAuthToken = () => forwardedAuthToken;
